import React, { forwardRef } from 'react';
import ProactiveIdentificationGuidance from './ProactiveIdentificationGuidance';
import Prognosis from './Prognosis';
import PrognosisTable from './PrognosisTable';

interface PrognosisSectionProps {
  fullName: string;
  prognosisFromData: string;
  slug: string | undefined;
  isUpdatedPronosis: boolean;
  setIsUpdatedPrognosis: React.Dispatch<React.SetStateAction<boolean>>;
}

const PrognosisSection = forwardRef<HTMLDivElement, PrognosisSectionProps>(
  (
    {
      fullName,
      prognosisFromData,
      slug,
      isUpdatedPronosis,
      setIsUpdatedPrognosis,
    },
    ref
  ) => {
    return (
      <>
        <Prognosis
          fullName={fullName}
          prognosisFromData={prognosisFromData}
          slug={slug}
          isUpdatedPronosis={isUpdatedPronosis}
          setIsUpdatedPrognosis={setIsUpdatedPrognosis}
          ref={ref}
        />
        <ProactiveIdentificationGuidance />
        <PrognosisTable
          slug={slug ?? ''}
          isUpdatedPronosis={isUpdatedPronosis}
        />
      </>
    );
  }
);

export default PrognosisSection;
